/**
 * @fileoverview Data model to hold subscription info for a single license pack.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

export class LicensePackOption {
  /**
   * @param {{
   *   id: number,
   *   name: string,
   *   availableCount: number,
   *   neededCount: number,
   * }} params
   */
  constructor(params) {
    /** @type {number} */
    this.id = params.id;
    /** @type {string} */
    this.name = params.name;
    /** @type {number} */
    this.availableCount = params.availableCount;
    /** @type {number} */
    this.neededCount = params.neededCount;
  }

  /**
   * @param {!LicensePackOptionJson} json
   * @return {!LicensePackOption}
   */
  static fromJSON(json) {
    return new LicensePackOption({
      id: json['id'],
      name: json['name'],
      availableCount: json['availableCount'],
      neededCount: json['neededCount'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *   id: number,
 *   name: string,
 *   availableCount: number,
 *   neededCount: number,
 * }}
 */
export let LicensePackOptionJson;
